import { apiClient, handleApiResponse, ApiResponse } from './client';

export interface Currency {
    code: string;
    symbol: string;
    name: string;
    isMajor?: boolean;
}

export interface CurrencyConfig {
    currencies: Currency[];
    supportedCodes: string[];
    majorCodes: string[];
}

export const currencyService = {
    getCurrencies: async (): Promise<ApiResponse<CurrencyConfig>> => {
        const response = await apiClient.get('/currency');
        return handleApiResponse(response);
    },
};
